import axios from './providers/aiAxios';

const agentService = {
    createAgent(body) {
        return axios.post('/api/agents/v2/create', body, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    getAgents(companyId, page = 1, limit = 10) {
        return axios.get('/api/agents/v2/store', {
            params: {
                companyId,
                page,
                limit
            }
        });
    },
    getAgentById(agentId) {
        return axios.get(`/api/agents/v2/details/${agentId}`);
    },
    uploadAgentAvatar(body) {
        return axios.post('/api/agents/v2/upload-avatar', body, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    removeDocument(agentId, filename) {
        return axios.delete(`/api/agents/v2/deleteFile/${agentId}/${filename}`);
    },
    updateAgent(agentId, body) {
        return axios.put(`/api/agents/v2/update/${agentId}`, body, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    deleteAgent(agentId, userId) {
        return axios.delete(`/api/agents/v2/${agentId}`, {
            data: { userId: userId }
        });
    },
    getAgentsByAssignment(params) {
        return axios.get('/api/agents/v2/list', { params });
    },
    assignAgent(body) {
        return axios.post('/api/agents/v2/assign', body);
    },
    unassignAgent(body) {
        return axios.post('/api/agents/v2/unassign', body);
    }
}

export default agentService;
